import React, {useState, useEffect} from "react";
import Accordion from "../../components/accordion/Accordion";
import {cleanDrops} from "../../hooks/helpers";
import ImgEncabezado from "../../components/imagenEncabezado/ImgEncabezado";
import ApplicantsTable from "./components/ApplicantsTable";
import {useLocation, useHistory} from "react-router-dom";
import AddProgramModal from "./components/AddModal";
import HeadView from "../../containers/HeadView";
import {ButtonWithIcon} from "../../styles/Butttons";
import {ReactComponent as PlusIcon} from "../../assets/icons/plus.svg";
import CoursesList from "./components/CoursesList";
import EmblemProvider from "../../context/EmblemProvider";

function useQuery() {
   return new URLSearchParams(useLocation().search);
}

export default function EmblemProgramView({theme}) {
   const [status, setStatus] = useState([0, 0, 0]);
   const [showModal, setShowModal] = useState(false);
   const [showAddSuccess, setAddSuccess] = useState(false);

   let location = useLocation();
   let query = useQuery();
   let history = useHistory();

   useEffect(() => {
      setShowModal(!!query.get("addModal"));
   }, []);

   const changeMode = (newVal, key) => {
      let nStatus = cleanDrops(status.length, key, newVal);
      setStatus([...nStatus]);
   };

   const closeModal = () => {
      history.replace(location.pathname);
      setShowModal(false);
      setAddSuccess(false);
   };
   const openModal = () => {
      history.push("/offer/add/3");
      setShowModal(true);
   };

   const save = (data) => {
      console.log("adas", data);
      setAddSuccess(true);
   };

   return (
      <EmblemProvider>
         <HeadView>
            <></>
            <>
               <ButtonWithIcon action={openModal} text="Nuevo" Icon={PlusIcon} />
            </>
         </HeadView>
         <ImgEncabezado
            theme={theme}
            title="Imagenes encabezado para program emblem"
            status={status[0]}
            changeMode={(val) => changeMode(val, 0)}
            titleDesc="Descripción general Programa Emblem"
            idUpdate={3}
            linkWeb="programa_emblem"
            nameUpdate="Emblem"
         />
         <Accordion theme={theme} title="lista experiencias domecq academy" status={status[1]} changeMode={(val) => changeMode(val, 1)}>
            <CoursesList theme={theme} />
         </Accordion> 
         <Accordion theme={theme} title="lista de solicitantes" status={status[2]} changeMode={(val) => changeMode(val, 2)}>
            <ApplicantsTable theme={theme} />
         </Accordion>
         <AddProgramModal showSuccess={showAddSuccess} close={closeModal} save={save} isOpen={showModal} theme={theme} />
      </EmblemProvider>
   );
}
